<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/businessIntranet/findMemberRoleForAdminList.action"
                    ref="intranetBusinessMemberRoleManagementTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="关键词搜索" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.intranetBusinessMemberRoleManagementTable.search()" type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="会员名称"
            prop="name">
        </el-table-column>
        <el-table-column
            label="会员说明"
            prop="introduce">
        </el-table-column>
        <el-table-column
            label="价格(元)"
            prop="price">
          <template scope="scope">
             {{scope.row.price/100}}
          </template>
        </el-table-column>

        <el-table-column
                label="会员时长"
                prop="memberDays">
          <template scope="scope">
            {{scope.row.memberDays}}
          </template>
        </el-table-column>
        <el-table-column
                label="会员标签"
                prop="memberDays">
          <template scope="scope">
            {{scope.row.userTag}}
          </template>
        </el-table-column>

        <el-table-column
                label="状态"
                prop="status">
          <template scope="scope">
                <span style="color:#fcb205" v-if="scope.row.status == 1">
                         上架
                  </span>
            <span  v-if="scope.row.status == 2">
                         下架
                  </span>
          </template>
        </el-table-column>

        <el-table-column
            label="操作">
          <template scope="scope">
            <el-button :confirm-data="{id:scope.row.id,status:scope.row.status==1?2:1}" :style="{color:scope.row.status==1?'#f56c6c':'#67c23a'}" @onConfirm="$refs['intranetBusinessMemberRoleManagementTable'].search()"
                       :confirm-text="scope.row.status==1?'下架':'上架'" requestUrl="businessIntranet/changeStatus.action"
                       type="text"
                       v-confirm>{{scope.row.status==1?'下架':'上架'}}
            </el-button>

            <el-button type="text" size="mini" @click="$router.push({path:'/home/intranetBusinessMemberRoleItem',query:{'id':scope.row.id}})">修改</el-button>

          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranet_business_member_role_management',
  data: function () {
    return {
      queryParams: {}
    }
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.intranetBusinessMemberRoleManagementTable.search()
    }
  },
  filters: {}
}
</script>

<style scoped>
</style>
